export const getScore = (scoresMap: Map<number, number>, playerId: number) => {
    return scoresMap.get(playerId) ?? 0;
}

export const getLeadingPlayerScore = (scoresMap: Map<number, number>) => {
    let maxScore = 0;
    scoresMap.forEach((v, k) => {
        if (v > maxScore) {
            maxScore = v;
        }
    });

    return maxScore;
}